var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgYoutube = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18485_2547)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0.485352H0V40.4854H40V0.485352ZM11.3317 10.1405H28.6683C29.8447 10.1405 30.9728 10.6732 31.8044 11.6219C32.6363 12.5702 33.1035 13.8566 33.1035 15.1982V25.7725C33.1035 27.1141 32.6363 28.4005 31.8044 29.3488C30.9728 30.2975 29.8447 30.8302 28.6683 30.8302H11.3317C10.1553 30.8302 9.02723 30.2975 8.19559 29.3488C7.36369 28.4005 6.89655 27.1141 6.89655 25.7725V15.1982C6.89655 13.8566 7.36367 12.5702 8.19559 11.6219C9.02723 10.6732 10.1553 10.1405 11.3317 10.1405ZM17.4558 25.6947L25.3179 21.097V21.1015C25.5198 20.9835 25.647 20.7465 25.647 20.4877C25.647 20.2288 25.5198 19.9918 25.3179 19.8738L17.4558 15.2761C17.2685 15.1655 17.0441 15.1741 16.8638 15.2992C16.6833 15.424 16.573 15.6472 16.5728 15.8877V25.0831C16.573 25.3236 16.6833 25.5469 16.8638 25.6716C17.0441 25.7967 17.2685 25.8054 17.4558 25.6947Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18485_2547"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.485352,
    width: 40,
    height: 40,
    rx: 5.51724,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/youtube.7ddf7636.svg";
export { ForwardRef as ReactComponent };